import React from 'react'
import { connect, useDispatch } from 'react-redux'
import flowRight from 'lodash/flowRight'
import includes from 'lodash/includes'
import { reduxForm, SubmissionError, formValueSelector } from 'redux-form'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import { translate } from 'loankeeper-common/helpers'
import transformProps from 'loankeeper-common/containers/transformProps'
import withCallAPI from 'loankeeper-common/containers/withCallAPI'
import { destroy as destroyFetcher } from 'loankeeper-common/helpers/SimpleFetchManager'

import { Client } from '../../../WebAPI'
import { LKModalContainer, actions as LKModalActions } from '../../shared/LKModal'
import { useLivedata } from '../../shared/containers/withLivedata'
import { withUserConfig, withSystemConfig } from '../../shared'
import {
  loadClientLinkedFiles,
  loadClientDetails,
  getClientReqFields,
  getClientSelects,
  checkReqFields,
} from '../../../store/client'
import { beforeConvAddEdit, view as eventView } from '../../../store/event'

import commonContainers from '../containers/common'
import * as mainTabFormPieces from '../containers/mainTabFormPieces'
import * as detailsTabFormPieces from '../containers/detailsTabFormPieces'
import { printReport } from '../helpers'
import { isCheckboxSelected, isDateOfBirthBetween } from '../CashInOut/utils'
import { translateLKMessage, translateFrmWebMsg } from '../translate'
import { FORM_NAME } from './constants'
import { accEntryConvAddEdit } from 'src/store/accEntry'
import { accountViewBalance } from 'src/store/account'

let session = {}

let isResubmit = false

export function markResubmit() {
  isResubmit = true
}

export const reduxFormContainer = flowRight(
  withRouter,
  reduxForm({
    form: FORM_NAME,
    validate: (values, ownProps) => {
      const errors = {}
      let otherErrors = {}

      if (values.CardNumber !== values.CardNumberConfirm) {
        errors.CardNumberConfirm = translate('frm_web_messages-DO_NOT_MATCH')
      }

      if (
        !(
          includes(['OrderConvertInCashEdit', 'OrderConvertInCashCopy'], ownProps.name) &&
          ownProps.OperTypeID === 7 &&
          ownProps.clientDetails.ClientID === 0
        )
      ) {
        otherErrors =
          ownProps.OperTypeID === 7
            ? detailsTabFormPieces.validate(values, ownProps)
            : mainTabFormPieces.validate(values)
      }

      if (!values.buyAmountA) {
        errors.buyAmountA = translateLKMessage('ERR_REQUIRED_FIELD')
      }

      if (!values.sellAmountB) {
        errors.sellAmountB = translateLKMessage('ERR_REQUIRED_FIELD')
      }

      if (!values.ccyBuyRate) {
        errors.ccyBuyRate = translateLKMessage('ERR_REQUIRED_FIELD')
      }

      if (!values.ccySellRate) {
        errors.ccySellRate = translateLKMessage('ERR_REQUIRED_FIELD')
      }

      return {
        ...otherErrors,
        ...errors,
      }
    },

    onAddedClient: async (Data, values, ownProps) => {
      ownProps.change('CardNumberSearch', values.CardNumber)
      ownProps.change('AddUserInDB', '0')
      const searchvalue = values.CardNumber
      // 1. Request client search
      // 2. Check if client exactly one client is found
      // 3. Client is just recently created so has to be not black listed
      // 4. Request client details
      //could not locate exact place 'client_Search_api'
      const { Data: Clients } = await Client.search({
        page: 'searchexact',
        searchfield: 'personalno',
        searchflags: '1110001',
        searchvalue,
      })

      if (Clients.length === 1) {
        ownProps.change('clientID', Data.ClientID)
        ownProps.change('clientHash', Data.HashSum_ClientID_)
        ownProps.change('isClientSelected', true)
        ownProps.change('clientIsChosen', true)

        await ownProps.loadClientDetails({
          clientId: Data.ClientID,
          clientHash: Data.HashSum_ClientID_,
        })
      }
    },

    onSubmitFail: (errors, dispatch) => {
      if (errors) {
        dispatch(
          LKModalActions.openInfo(
            errors._error || translate('LKMESSAGE-ERR_FILL_REQUIRED_FIELDS'),
            errors._error ? 'pan_no_isocommrate' : 'ERR_FILL_REQUIRED_FIELDS',
          ),
        )
      }
    },

    onSubmit: async (values, dispatch, ownProps) => {
      console.log(ownProps.OperTypeID)
      const RateSell = ownProps.CCYCommercialRates.filter((rate) => {
        if (values.debitCCY === rate.CCY && values.creditCCY === rate.CCY2) {
          return { rate }
        }

        return undefined
      })

      const RateBuy = ownProps.CCYCommercialRates.filter((rate) => {
        if (values.creditCCY === rate.CCY && values.debitCCY === rate.CCY2) {
          return { rate }
        }

        return undefined
      })
      if (
        (!RateSell.length || !RateBuy.length) &&
        values.alreadyDefinedRates === '1' &&
        values.CCYRateType === 'commercial'
      ) {
        return Promise.reject(new SubmissionError({ _error: translate('frm_acc_conv_add-pan_no_isocommrate') }))
      }

      const rateBuyVal =
        values.sellBCheck === '1' && values.buyACheck === '1'
          ? values.ccyBuyRate
          : RateBuy.length > 0
          ? RateBuy[0].RateBuy
          : null
      const rateSellVal =
        values.sellBCheck === '1' && values.buyACheck === '1'
          ? values.ccySellRate
          : RateSell.length > 0
          ? RateSell[0].RateSell
          : null

      if (
        moment(values.DocDate, 'DD.MM.YYYY').isBefore(moment(ownProps.OpenDay, 'DD.MM.YYYY')) &&
        !ownProps.permissions.MAKE_CLOSEDAY_ENTRIES
      ) {
        return Promise.reject(new SubmissionError({ DocDate: 'invalid' }))
      }

      if (values.ClientType !== '3' && isCheckboxSelected(values.DOBCheck)) {
        if (
          isCheckboxSelected(values.AddUserInDB) &&
          isDateOfBirthBetween(values.DOB, ownProps.AgeLimitMin, ownProps.AgeLimitMax)
        ) {
          return Promise.reject(new SubmissionError({ DOB: 'invalid' }))
        }

        if (
          !isCheckboxSelected(values.AddUserInDB) &&
          isDateOfBirthBetween(values.DOB, ownProps.AgeLimitMin, ownProps.AgeLimitMax)
        ) {
          return Promise.reject(new SubmissionError({ DOB: 'invalid' }))
        }
      }

      if (!isResubmit && ownProps.OperTypeID === 7) {
        const apiArgs = values.clientIsChosen
          ? {
              ClientID: values.clientID,
              HashSum_ClientID_: values.clientHash,
            }
          : {
              Name: values.Name,
              Surname: values.Surname,
              Name_ALT: values.Name_ALT,
              Surname_ALT: values.Surname_ALT,
              CellPhone: values.CellPhone,
            }

        try {
          const beforeConvAddEditParams = {
            SP_ACT: values.action === 'edit' ? 1 : 0,
            AMLOperTypeID: 60,
            OperTypeID: ownProps.OperTypeID,
            Amount: values.buyAmountA,
            AmountB: values.sellAmountB,
            CCY: values.debitCCY,
            CCYB: values.creditCCY,
            OperDate: values.DocDate,
            DebitAccID: values.DebitAccID,
            HashSum_DebitAccID_: values.DebitAccHash,
            CreditAccID: values.CreditAccID,
            HashSum_CreditAccID_: values.CreditAccHash,
            IDDocID: values.IDDoc && values.IDDoc.ID,
            HashSum_IDDocID_: values.IDDoc && values.IDDoc.HashSum_IDDocID_,
            PersonalNo: values.CardNumber,
            ...apiArgs,
          }

          if (
            includes(['OrderConvertInCashCopy', 'OrderConvertInCashEdit'], ownProps.name) &&
            ownProps.OperTypeID === 7
          ) {
            beforeConvAddEditParams.ClientType = ownProps.clientDetails.ClientType
          } else {
            beforeConvAddEditParams.ClientType = values.clientType
          }

          if (
            ownProps.OperTypeID === 7 &&
            ((ownProps.clientDetails && ownProps.clientDetails.ClientType === 0) ||
              values.clientType === 0 ||
              (!values.clientType && !ownProps.clientDetails))
          ) {
            beforeConvAddEditParams.ClientType = 1
          }

          const { ErrorLevel, WHLSessionID, HashSum_WHLSessionID_ } = (
            await dispatch(beforeConvAddEdit(beforeConvAddEditParams))
          ).payload

          session = { WHLSessionID, HashSum_WHLSessionID_, ErrorLevel }

          if (ErrorLevel === 150 || ErrorLevel === 200) {
            const Data = (await dispatch(eventView({ WHLSessionID, HashSum_WHLSessionID_ }))).payload

            dispatch(
              LKModalActions.open({
                name: ErrorLevel === 150 ? 'ClientValidationResultsConfirm' : 'ClientValidationResults',
                Data,
                ErrorLevel,
              }),
            )

            return Promise.reject()
          }
        } catch (e) {
          dispatch(
            LKModalActions.openError(
              translateLKMessage((e.Error && (e.Error.Message || e.Error.Text)) || 'HINT_ERR_TITLE'),
            ),
          )

          return Promise.reject()
        }
      } else {
        isResubmit = false
      }

      let clientAddPromise = Promise.resolve()
      let clientCheckFilesPromise = Promise.resolve()
      if (ownProps.OperTypeID === 7) {
        if (!values.clientIsChosen && values.AddUserInDB === '1') {
          clientAddPromise = Client.checkDublicate({ typeid: 1, own_id: 0, serial: values.CardNumber })
            .then(({ ClientDupCheckResponse }) => {
              if (ClientDupCheckResponse.Result === 1) {
                throw new Error(translate('LKMESSAGE-ERR_DUPLICATE_CLIENT'))
              }
            })
            .then(() => {
              let apiParams = {}
              if (values.action === 'edit') {
                apiParams = {
                  CellPhone: values.CellPhone,
                  Code: values.CellPhoneValidateCode,
                  ClientID: values.clientID,
                  ClientHash: values.clientHash,
                  IDCardTypeID: values.IDCardTypeID,
                }
              } else {
                apiParams = {
                  PersonalNo: values.CardNumber,
                  CellPhone: values.CellPhone,
                  Code: values.CellPhoneValidateCode,
                  IDCardTypeID: values.IDCardTypeID,
                }
              }
              Client.contactVerifySMS(apiParams).catch(() => {
                throw new Error(translateFrmWebMsg('ERR_CODE_NOT_FOUND'))
              })
            })
            .then(() =>
              Client.submitAddClientFormData({
                action: 'add',
                ClientType: '1',
                ReqFieldGroupID: 9,
                IND_Name: values.Name,
                IND_Surname: values.Surname,
                CityID: values.CityID,
                Address: values.Address,
                IDCardTypeID: values.IDCardTypeID,
                IDCardIssuerID: values.IDCardIssuerID,
                FullName: values.FullName,
                IND_DOB: values.DOB,
                CardNumber: values.CardNumber,
                IDCardRegDate: values.IDCardRegDate,
                CellPhone: values.CellPhone,
                OtherIDNumber: values.OtherIDNumber,
                IDValidityDate: values.IDValidityDate,
                CitizenshipID: values.CitizenshipID,
                CellPhoneValidateCode: values.CellPhoneValidateCode,
              }).then(({ Data }) => {
                ownProps.onAddedClient(Data, values, ownProps)
                if (values.uploadClientIDCopyWarning) {
                  throw new Error(translate('LKMESSAGE-ERR_IDCOPY_REQUIRED_FOR_CONV'))
                }
              }),
            )
        } else if (values.clientIsChosen) {
          clientAddPromise = Client.checkReqFields({
            ClientID: values.clientID,
            HashSum_ClientID_: values.clientHash,
            ID: 9,
          })
          //QUESTIONS about failed fields
          // clientAddPromise = dispatch(checkReqFields({
          //   ClientID: values.clientID,
          //   HashSum_ClientID_: values.clientHash,
          //   ID: 9,
          // }))
        }

        if (values.uploadClientIDCopyWarning) {
          if (values.clientIsChosen) {
            const clientLinkedFilesResult = await ownProps.loadClientLinkedFiles({
              clientId: values.clientID,
              clientHash: values.clientHash,
            })

            if (loadClientLinkedFiles.fulfilled.match(clientLinkedFilesResult)) {
              if (clientLinkedFilesResult.payload.length === 0) {
                throw new Error(translate('LKMESSAGE-ERR_IDCOPY_REQUIRED_FOR_CONV'))
              }
            }
          } else if (
            values.AddUserInDB === '0' ||
            !values.CardNumber ||
            values.CardNumber !== values.CardNumberConfirm
          ) {
            clientCheckFilesPromise = Promise.reject(new Error(translate('LKMESSAGE-ERR_FILL_REQUIRED_FIELDS')))
          }
        }
      }

      const finalPromiseToChainOn = Promise.all([clientAddPromise, clientCheckFilesPromise])

      return finalPromiseToChainOn
        .then(() => {
          const newData = {
            ...values,
            PersonalNo: values.CardNumber,
            DocNo: values.DocNo || 0,
            HashSum_DebitAccID_: values.DebitAccHash,
            HashSum_CreditAccID_: values.CreditAccHash,
            Amount: parseFloat(values.buyAmountA),
            AmountB: parseFloat(values.sellAmountB),
            OperTypeID: ownProps.OperTypeID,
            LoanID: ownProps.params && ownProps.params.LoanID,
            HashSum_LoanID_: ownProps.params && ownProps.params.LoanHash,
            Rate1: rateSellVal,
            Rate2: rateBuyVal,
          }
          const { action } = newData

          if (ownProps.OperTypeID === 7) {
            newData.WHLSessionID = session.WHLSessionID
            newData.HashSum_WHLSessionID_ = session.HashSum_WHLSessionID_
          }

          delete newData.CCYRateType
          delete newData.CreditAccBalance
          delete newData.CreditAccNo
          delete newData.CreditAccHash
          delete newData.CreditChosenAccNo
          delete newData.CreditTitleUNI
          delete newData.DebitAccBalance
          delete newData.DebitAccNo
          delete newData.DebitAccHash
          delete newData.DebitChosenAccNo
          delete newData.DebitTitleUNI
          delete newData.OpenAgain
          delete newData.alreadyDefinedRates
          delete newData.buyACheck
          delete newData.buyAmountA
          delete newData.ccyBuyRate
          delete newData.ccySellRate
          delete newData.creditCCY
          delete newData.debitCCY
          delete newData.sellAmountB
          delete newData.sellBCheck

          if (newData.action === 'add') {
            delete newData.OID
            delete newData.HashSum_OID_
            delete newData.EntryID
            delete newData.HashSum_EntryID_
          }

          if (newData.IDValidityDateCheck === '0' && !newData.IDValidityDate) newData.IDValidityDate = '01.01.1900'

          delete newData.MobileNumber
          delete newData.CardNumber
          delete newData.CardNumberSearch
          delete newData.DOB
          delete newData.DOBCheck
          delete newData.IDCardTypeID
          delete newData.OtherIDNumber
          delete newData.IDCardIssuerID
          delete newData.IDCardRegDate
          delete newData.IDCardRegDateCheck
          delete newData.IDValidityDate
          delete newData.IDValidityDateCheck
          delete newData.AddUserInDB
          delete newData.CitizenshipID
          delete newData.print
          delete newData.fillClientDetailsWarning
          delete newData.uploadClientIDCopyWarning
          delete newData.clientIsChosen
          delete newData.clientType
          delete newData.clientID
          delete newData.clientHash
          delete newData.IDCardTypeInit
          delete newData.FullName
          delete newData.Client
          delete newData.LinkedFiles
          delete newData.CityID
          delete newData.Address
          delete newData.action
          delete newData.clientWatched
          delete newData.MoneyTransferCountryID
          delete newData.ccyOfficalRateNotFound
          delete newData.Delegate

          if (newData.IDDoc && newData.IDDoc.ID) {
            newData.IDDocID = newData.IDDoc.ID
            newData.HashSum_IDDocID_ = newData.IDDoc.HashSum_IDDocID_
          }

          delete newData.IDDoc

          const isCompany = values.ClientType === '3'

          if (values.clientID && values.clientHash) {
            if (isCompany) {
              newData.Company_ClientID = values.clientID
              newData.HashSum_Company_ClientID_ = values.clientHash

              if (values.Delegate) {
                newData.ClientID = values.Delegate.ID
                newData.HashSum_ClientID_ = values.Delegate.HashSum_ClientID_
              }
            } else {
              newData.ClientID = values.clientID
              newData.HashSum_ClientID_ = values.clientHash
            }
          }

          // return Order.addConv({ action }, newData)
          //UPDATED API REQUEST acc_conv_add_api
          return dispatch(
            accEntryConvAddEdit({
              ...newData,
              action,
            }),
          )
        })
        .then((response) => {
          if (!accEntryConvAddEdit.fulfilled.match(response)) {
            throw { Error: { Message: response.payload.message, FailedFields: response.payload.FailedFields } }
          }
          ownProps.closeModal()

          if (ownProps.onOrderAddEdit) ownProps.onOrderAddEdit(response.payload)

          dispatch(destroyFetcher(ownProps.checkCreditAccountFetcherName))
          dispatch(destroyFetcher(ownProps.checkDebitAccountFetcherName))

          if (values.OpenAgain) {
            let name = ''
            if (ownProps.OperTypeID === 7 && ownProps.name === 'OrderConvertInCashCopy') {
              name = 'OrderConvertOnCashboxInNavigation'
            } else if (ownProps.OperTypeID === 6 && ownProps.name === 'OrderConvertOnAccountCopy') {
              name = 'OrderConvertOnAccountInNavigation'
            } else {
              name = ownProps.name
            }

            dispatch(LKModalActions.open({ name }))
          }

          if (values.action === 'add' && values.print === '1') {
            printReport({
              dispatch,
              OperTypeID: ownProps.OperTypeID,
              page: ownProps.OperTypeID === 6 ? 'printconvacc' : 'printconvcash',
              printOption: values.printOption,
              EntryID: response.payload.EntryID,
              HashSum_EntryID_: response.payload.HashSum_EntryID_,
              OID: response.payload.OID,
              HashSum_OID_: response.payload.HashSum_OID_,
              history: ownProps.history,
            })
          }
        })
        .catch((error) => {
          if (error.Error && error.Error.FailedFields && error.Error.FailedFields.length) {
            const submissionErrors = {}

            error.Error.FailedFields.forEach((failedField) => {
              if (failedField.FName === 'DebitAccTypeID') {
                submissionErrors.DebitAccNo = 'invalid'
              }

              if (failedField.FName === 'CreditAccTypeID') {
                submissionErrors.CreditAccNo = 'invalid'
              }

              throw new SubmissionError(submissionErrors)
            })
          } else {
            const errIDCOPY = translate('LKMESSAGE-ERR_IDCOPY_REQUIRED_FOR_CONV')
            dispatch(
              values.uploadClientIDCopyWarning && error.message === errIDCOPY
                ? LKModalActions.openInfo(
                    translateLKMessage(error.message || error.Error.Message || error.Error.Text),
                    () => {
                      // TODO: investigate this
                      dispatch(LKModalActions.open({ name: 'ClientDetailForNoLinkFile' }))
                    },
                  )
                : LKModalActions.openInfo(translateLKMessage(error.message || error.Error.Message || error.Error.Text)),
            )
          }
        })
    },
  }),
)

const commonConvContainersI = flowRight(
  commonContainers,

  withUserConfig(['CashAccounts', 'MyCountryID', 'NodeID', 'Print_After_Client_Add']),

  (Component) => (props) => {
    let liveDataResult = {}

    try {
      liveDataResult = useLivedata(['CCYOfficalRates', 'CCYCommercialRates'])
    } catch (err) {
      console.error(err)
    }

    const CCYCommercialRates = liveDataResult.CCYCommercialRates
      ? liveDataResult.CCYCommercialRates.map((rate) => ({
          ...rate,
          RateBuy: parseFloat(rate.RateBuy).toFixed(15),
          RateSell: parseFloat(rate.RateSell).toFixed(15),
        }))
      : []

    const CCYOfficalRates = liveDataResult.CCYOfficalRates
      ? liveDataResult.CCYOfficalRates.map((rate) => ({
          ...rate,
          RateBuy: parseFloat(rate.RateBuy).toFixed(15),
          RateSell: parseFloat(rate.RateSell).toFixed(15),
        }))
      : []

    return <Component {...props} CCYOfficalRates={CCYOfficalRates} CCYCommercialRates={CCYCommercialRates} />
  },
)

const commonConvContainersII = flowRight(
  withSystemConfig(['AgeLimitMin', 'AgeLimitMax', 'CashDocAgeMin', 'CashDocAgeMax']),
  transformProps((props) => {
    const CCYCommercialRates = props.CCYCommercialRates.map((rate) => ({
      ...rate,
      RateBuy: parseFloat(rate.RateBuy).toFixed(15),
      RateSell: parseFloat(rate.RateSell).toFixed(15),
    }))

    const ccyRatesInfo1 = CCYCommercialRates.find((rate) => rate.CCY === 'GEL' && rate.CCY2 === 'USD') || {}
    const ccyRatesInfo2 = CCYCommercialRates.find((rate) => rate.CCY === 'USD' && rate.CCY2 === 'GEL') || {}

    const newProps = {
      ...props,
      checkDebitAccountFetcherName: 'checkDebitAccountFetcherName',
      checkCreditAccountFetcherName: 'checkCreditAccountFetcherName',
      CCYCommercialRates,
      initialValues: {
        ClientType: '1',
        action: 'add',
        debitCCY: 'GEL',
        creditCCY: 'USD',
        buyACheck: '1',
        sellBCheck: '0',
        buyAmountA: 0,
        sellAmountB: 0,
        alreadyDefinedRates: '1',
        ccyBuyRate: !ccyRatesInfo2.RateBuy ? '1' : ccyRatesInfo2.RateBuy,
        ccySellRate: !ccyRatesInfo1.RateSell ? '1' : ccyRatesInfo1.RateSell,
        CCYRateType: 'commercial',
        OpCodeID: props.OpCode[0] ? props.OpCode[0].ID : 0,
        DocDate: props.OpenDay,
      },
    }

    if (props.OperTypeID === 7) {
      const GELAccount = props.CashAccounts.find((acc) => acc.CCY === 'GEL') || {}
      const USDAccount = props.CashAccounts.find((acc) => acc.CCY === 'USD') || {}

      return {
        ...newProps,
        initialValues: {
          ...newProps.initialValues,
          DebitAccNo: GELAccount.AccNo,
          DebitTitleUNI: GELAccount.TitleUNI,
          DebitAccID: GELAccount.AccountID,
          DebitAccHash: GELAccount.HashSum_AccountID_,
          DebitAccBalance: props.debitBalance,
          DebitChosenAccNo: GELAccount.AccNo,
          CreditAccNo: USDAccount.AccNo,
          CreditTitleUNI: USDAccount.TitleUNI,
          CreditAccID: USDAccount.AccountID,
          CreditAccHash: USDAccount.HashSum_AccountID_,
          CreditAccBalance: props.creditBalance,
          CreditChosenAccNo: USDAccount.AccNo,
          Name: '',
          Surname: '',
          CityID: 1,
          Address: '',
          DOB: '',
          DOBCheck:
            props.requiredFields && props.requiredFields.IND_DOB && props.requiredFields.IND_DOB.Active === 1
              ? '1'
              : '0',
          MobileNumber: '',
          IDCardTypeID: 1,
          CardNumber: '',
          CardNumberSearch: '',
          OtherIDNumber: '',
          IDCardIssuerID: 1,
          IDCardRegDate: props.OpenDay,
          IDCardRegDateCheck:
            props.requiredFields &&
            props.requiredFields.IDCardRegDate &&
            props.requiredFields.IDCardRegDate.Active === 1
              ? '1'
              : '0',
          IDValidityDate: props.OpenDay,
          IDValidityDateCheck:
            props.requiredFields &&
            props.requiredFields.IDValidityDate &&
            props.requiredFields.IDValidityDate.Active === 1
              ? '1'
              : '0',
          AddUserInDB: '0',
          CitizenshipID: props.MyCountryID,
          MoneyTransferCountryID: props.clientSelects.Country[0].ID,
        },
      }
    }

    return newProps
  }),

  reduxFormContainer,
)

export const convertOnAccountContainers = flowRight(LKModalContainer(), commonConvContainersI, commonConvContainersII)

export const convertInCashContainers = flowRight(
  LKModalContainer(),
  commonConvContainersI,
  (Component) => (props) => {
    const { closeModal } = props

    const dispatch = useDispatch()

    const invalidCashAcounts =
      !props.CashAccounts ||
      !props.CashAccounts.length ||
      !props.CashAccounts.some((acc) => acc.CCY === 'USD') ||
      !props.CashAccounts.some((acc) => acc.CCY === 'GEL')

    React.useEffect(() => {
      if (invalidCashAcounts) {
        dispatch(LKModalActions.openError(translateFrmWebMsg('NO_CASH_ACC'), 'NO_CASH_ACC'))
        closeModal()
      }
    }, [closeModal, invalidCashAcounts, dispatch])

    if (invalidCashAcounts) {
      return null
    }

    return <Component {...props} />
  },
  connect(undefined, (dispatch) => ({
    getClientReqFields: (params) => dispatch(getClientReqFields(params)),
    getClientSelects: (params) => dispatch(getClientSelects(params)),
    accountViewBalance: (params) => dispatch(accountViewBalance(params)),
  })),

  (Component) => {
    class WrappedUcc extends React.Component {
      constructor(props) {
        super(props)
        console.log(props)
        this.Wrapped = withCallAPI({
          APICall: [
            // Client.getSelects,
            //UPDATED API REQUEST client_lookups_api
            (params) => props.getClientSelects(params),
            // Client.getRequiredFields
            //UPDATED API REQUEST client_reqfields_api
            (params) => props.getClientReqFields(params),
            // Account.details,
            //UPDATED API REQUEST acc_account_view_api page: balance
            (params) =>
              props.accountViewBalance({
                AccountID: params.ID,
                HashSum_AccountID_: params.hash,
              }),
            // Account.details,
            //UPDATED API REQUEST acc_account_view_api page: balance
            (params) =>
              props.accountViewBalance({
                AccountID: params.ID,
                HashSum_AccountID_: params.hash,
              }),
          ],
          APIParams: [
            undefined,

            () => ({ groupid: 9, typeid: 1 }),

            ({ CashAccounts }) => {
              const account = CashAccounts.find((acc) => acc.CCY === 'GEL') || {}

              return {
                ID: account.AccountID,
                hash: account.HashSum_AccountID_,
                page: 'balance',
              }
            },

            ({ CashAccounts }) => {
              const account = CashAccounts.find((acc) => acc.CCY === 'USD') || {}

              return {
                ID: account.AccountID,
                hash: account.HashSum_AccountID_,
                page: 'balance',
              }
            },
          ],
          transformData: [
            // (response) => ({ clientSelects: response.Data }),
            //UPDATED API REQUEST client_lookups_api
            ({ payload: response }) => ({ clientSelects: response }),
            // (response) => {
            //UPDATED API REQUEST client_reqfields_api
            ({ payload: response }) => ({
              requiredFields: response.ReqFields.reduce(
                (result, current) => ({
                  ...result,
                  [current.FName]: current,
                }),
                {},
              ),
            }),
            ({ payload }) => ({ debitBalance: payload.Balance }),
            ({ payload }) => ({ creditBalance: payload.Balance }),
          ],
          withLoading: true,
        })(Component)
      }

      render() {
        const { Wrapped } = this

        return <Wrapped {...this.props} />
      }
    }

    return WrappedUcc
  },

  connect(
    (state) => ({
      clientWatched: formValueSelector(FORM_NAME)(state, 'clientWatched'),
    }),
    {
      loadClientLinkedFiles,
      loadClientDetails,
    },
  ),
  commonConvContainersII,
)
